"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaFeedEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const SocialMediaFeedDto_1 = require("./SocialMediaFeedDto");
const ValidationError_1 = require("../GS/ValidationError");
class SocialMediaFeedEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, socialMediaFeed) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            site: false
        };
        this._dependencies = dependencies;
        if (socialMediaFeed === undefined) {
            this._dto = new SocialMediaFeedDto_1.SocialMediaFeedDto();
        }
        else if (socialMediaFeed instanceof SocialMediaFeedDto_1.SocialMediaFeedDto) {
            this._dto = new SocialMediaFeedDto_1.SocialMediaFeedDto(socialMediaFeed);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (socialMediaFeed instanceof SocialMediaFeedEntity) {
            this._dto = new SocialMediaFeedDto_1.SocialMediaFeedDto(socialMediaFeed._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new SocialMediaFeedDto_1.SocialMediaFeedDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.locationId === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        this._setIsDirty(true);
    }
    getSite() {
        return this._dto.site;
    }
    setSite(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("site");
        this._requiredFieldsSetStatus.site = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("site", "Site is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("site", `Site has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.site) {
            return;
        }
        this._dto.site = _untrustedValue;
        this._setIsDirty(true);
    }
    getUrl() {
        return this._dto.url;
    }
    setUrl(untrustedValue) {
        const maxLength = 155;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("url");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("url", `Url has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.url) {
            return;
        }
        this._dto.url = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.socialMediaFeedDatastore
                    .getAsync(id, expand);
                delete this._locationEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Social Media Feed is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.socialMediaFeedDatastore.addAsync(dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.socialMediaFeedDatastore.updateAsync(dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Social Media Feed cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.socialMediaFeedDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.SocialMediaFeedEntity = SocialMediaFeedEntity;
//# sourceMappingURL=SocialMediaFeedEntity.js.map